import { CheckBox, FileUpload, FormattedString, InputFormCallout, InputFormCalloutProps } from "o4a-react";
import * as React from "react";
import * as Messages from "../../codegen/Messages";
import { gcsSecurityPractices } from "../../constants/docConstants";

export const enum Fields {
  File = "file",
  HasPrivateInfo = "hasPrivateInfo"
}

// eslint-disable-next-line max-len
export type SupportUploadFilePanelProps = Pick<InputFormCalloutProps, "title" | "targetId" | "onClose" | "onSubmit" | "componentRef">;

export const SupportUploadFilePanel = ({
  title,
  componentRef,
  targetId,
  onSubmit,
  onClose,
}: SupportUploadFilePanelProps): JSX.Element => (
  <InputFormCallout
    componentRef={componentRef}
    targetId={targetId}
    title={title}
    onSubmit={onSubmit}
    onClose={onClose}
    primaryButtonText={Messages.actions.upload()}
  >
    <FileUpload
      label={Messages.labels.file()}
      fieldName={Fields.File}
      required
    />
    <CheckBox
      fieldName={Fields.HasPrivateInfo}
      label={Messages.labels.filePrivateInfo()}
      tooltip={
          FormattedString(
            { inputText: Messages.hints.tooltipFilePrivateInfo(gcsSecurityPractices) },
          ) as unknown as string
        }
      switchCheckBoxSide
    />
  </InputFormCallout>
);
